import IScalarForm from "src/libs/scalars/interface/IScalarForm" 
import FieldChanger from "../FieldChanger"

/* Protopia Ecosystem component */
export interface IContentEditChildFieldProps {
   type: IScalarForm | undefined
   value: any
   subMenus?: IScalarForm[]
   origin?: any
}
const ContentEditChildField = (props: IContentEditChildFieldProps): JSX.Element => { 

    if( !props.type) {
        // return <></>
    }
    const onChange = ( value: any, field: string, dop: any ) => {

    }
    const onSubmenu = () => {

    }
    return <div className='landing-content-edit-child-field p-3 overflow-y-auto'>
       <FieldChanger 
            {...props.type}
            title={""}
            subtitle={""}
            dataSection="" 
            dataName=""
            value={ props.value || props.type?.default }
            editable
            onChange={onChange}
            noDefault={false}
            notClear
            subMenus={ props.subMenus }
            onSubMenu={onSubmenu}
            origin={props.origin}
        /> 
    </div>
}
export default ContentEditChildField